<template>
	<div class='main-mybody' style="padding-top: 1rem;" id='homeqi'>
		<a-form-model ref='ruleForm' :model="form" labelAlign='left' layout="inline" :rules='rules' hideRequiredMark>
			<div class='look_g'><div></div>員工信息</div>
			<a-row style="padding-bottom: 20px;">
				<a-col :span='12'>
					<div style="display:flex;">
						<div class="staff_name">員工姓名 :</div>
						<div class="border_sty">{{formview.realname}}</div>
					</div>
				</a-col>
				<a-col :span='12'>
					<div style="display:flex;justify-content:end">
						<div class="staff_name">員工編號 :</div>
						<div class="border_sty">{{formview.employee_number}}</div>
					</div>
				</a-col>
			</a-row>
			<a-row style="padding-bottom: 20px;">
				<a-col :span='12'>
					<div style="display:flex;">
						<div class="staff_name" slot='label' v-html='"部&emsp;門 :"' style="color: #000000;width: 3.3rem;justify-content: right;"></div>
						<div class="border_sty">{{formview.department}}</div>
					</div>
				</a-col>
				<a-col :span='12'>
					<div style="display:flex;justify-content:end">
						<div class="staff_name" slot='label' v-html='"職&emsp;位 :"' style="color: #000000;"></div>
						<div class="border_sty">{{formview.job}}</div>
					</div>
				</a-col>
			</a-row>
			<a-row style="padding-bottom: 20px;">
				<a-col :span='12'>
					<div style="display:flex;">
						<div class="staff_name">手機號碼 :</div>
						<div class="border_sty">{{formview.phone}}</div>
					</div>
				</a-col>
				<a-col :span='12'>
					<div style="display:flex;justify-content:end">
						<div class="staff_name">電子郵箱 :</div>
						<div class="border_sty">{{formview.email}}</div>
					</div>
				</a-col>
			</a-row>
			<a-row style="padding-bottom: 20px;">
				<a-col :span='12'>
					<div style="display:flex;">
						<div class="staff_name">入職時間 :</div>
						<div class="border_sty">{{formview.entry_date}}</div>
					</div>
				</a-col>
				<a-col :span='12'>
					<div style="display:flex;justify-content:end">
						<div class="staff_name">員工狀態 :</div>
						<div class="border_sty">{{formview.status}}</div>
					</div>
				</a-col>
			</a-row>

		</a-form-model>
	</div>
</template>

<script>
	import App from '@/assets/app.js';

	export default {
		props: ['pared'],
		data() {
			return {
				visible: true,
				rules: {},
				formview: {
					createtime: "",
					department: "",
					position: "",
					realname: "",
					sex: 0,
				},
				backform: {
					begindates: '',
					enddates: ''
				},
				form: {
					"type": 1, //類型 1 假期申請 2 外出 3加班
					"asktype": 1, // 1年假 2病假 3婚假 4產假 5陪產假 6喪假 7無薪休假 0其他
					"otherasktype": "", //  其他請假形式
					"remark": "",
					"begindate": "",
					enddate: '',
					"begintime": "9:00",
					// "enddate": "2021-6-7",
					"endtime": "18:00",
					day_hour: '',
					yearholiday_days: ''
				},
			
			}
		},
		watch: {
			form: {
				deep: true,
				handler(ev) {
				}
			}
		},
		mounted() {
			this.handimg()
		},
		methods: {
			handimg(record) {
				this.$ajax({
					method: 'post',
					url: this.$api.getAttenceApplyInfo,
					data: {
						applyid: this.pared.applyid || '',
						token: this.$store.state.token
					}
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						this.formview = res.data
						if (this.pared.applyid) {
							this.form = res.data
							this.form.num = Math.ceil(this.form.day_hour.split(' ')[0]);
							this.backform.begindates = this.form.begindate
							this.backform.enddates = this.form.enddate
						}
						// this.form.yearholiday_days = res.data.yearholiday_days
						setTimeout(() => {
							this.visible_bold = true;
						}, 100)
					} else {
						this.visible_bold = true
						App.oTool.warningT(res.data.qmismsg);
					}
				})
			},
		
			handleOk1() {}
		}
	}
</script>

<style lang="scss" scoped>
	#homeqi {
		.ant-select-dropdown-menu-item:hover:not(.ant-select-dropdown-menu-item-disabled) {
			background-color: red !important;
		}

		.ant-fullcalendar-today .ant-fullcalendar-value,
		.ant-fullcalendar-month-panel-current-cell .ant-fullcalendar-value {
			box-shadow: 0 0 0 1px red inset;
		}

		.ant-fullcalendar-selected-day .ant-fullcalendar-value,
		.ant-fullcalendar-month-panel-selected-cell .ant-fullcalendar-value {
			background: red;
		}

		.ant-radio-group-small {
			display: none;
		}

		.ant-fullcalendar-header {
			.ant-fullcalendar-year-select {
				width: 5rem;
				display: inline-block;
			}

			.ant-fullcalendar-month-select {
				width: 5rem;
				display: inline-block;
			}
		}

		.mayright {
			margin-left: 1rem;
			left: 2rem;
			position: relative;
		}

		.titName {
			font-size: 0.75rem !important;
			color: #000;
		}

		.comname {
			font-size: 0.75rem !important;
		}

		.ant-modal {
			top: 9vh;
		}

		.warp_min {
			vertical-align: top;
			width: 64%;
			height: 3rem;
			line-height: 3rem;
			font-size: 0.75rem;
			padding: .7rem 0;
			display: inline-block;
		}

		.warp_titlis {
			margin-right: .1rem;
			color: #000;
			width: 34.5%;
		}

		.ant-modal-content {
			border-radius: 10px;
		}



		

		.warp_btn {
			cursor: pointer;
			width: 1.5rem;
			color: #fff;
			display: inline-block;
			margin: 0 .1rem;
			height: 1.5rem;
			line-height: 1.5rem;
			text-align: center;
			border-radius: 10px;
		}

		.ant-modal-body {
			padding: 0;
			padding-top: 2.5rem;
		}

		.btn1 {
			cursor: pointer;
			width: 5rem;
			height: 2rem;
			font-size: .75rem;
			color: #fff;
			border: 0;
			border-radius: 5px;
			margin: 0 3.5rem;
		}

		.btnfour {
			cursor: pointer;
			width: 3.5rem;
			height: 1.5rem;
			font-size: .75rem;
			color: #fff;
			border: 0;
			border-radius: 20px;
			margin-left: 0.8rem;
			background-color: #a6b7c4;
		}

		.btnx {
			background-color: #0c8b97;
		}

		.btn2 {
			background-color: #f48d28;
		}

		.pos_ste {
			position: relative;
			// width: 2rem;
			font-size: .6rem;
			background-color: #ee7171;
			top: -3rem;
			left: 1rem;
		}
		.staff_name{
			display: flex;
    		align-items: center;
		}
		.border_sty{
			border: 1px solid #d9d9d9;
   			border-radius: 4px;
			padding: 4px 11px;
			margin-left: 1%;
			width: 70%;
			height: 1.75rem;
			display: flex;
			align-items: center;

		}
	}
</style>
